import calculateNetRecurringBenefit from "../calculation/calculationRecurringBenefit";

const getNetRecurringBenefitCategory = (initiative) => {
  if (!initiative || !initiative.impact) {
    return 'No value';
  }
  const initiativeImpacts = initiative.impact || [];
  let netBenefit = calculateNetRecurringBenefit(initiative);
  if (!initiative.hasFinancialImpact || initiativeImpacts.length === 0) {
    return 'No value';
  }
  if (netBenefit < 0) {
    return 'Negative value';
  }
  if (netBenefit === 0) {
    return 'ETB 0-ETB 1Mn';
  } else if (netBenefit > 0 && netBenefit <= 1) {
    return 'ETB 0-ETB 1Mn';
  } else if (netBenefit <= 10 && netBenefit > 1) {
    return 'ETB 1Mn-ETB 10Mn';
  } else if (netBenefit <= 50 && netBenefit > 10) {
    return 'ETB 10Mn-ETB 50Mn';
  } else if (netBenefit <= 100 && netBenefit > 50) {
    return 'ETB 50Mn-ETB 100Mn';
  } else if (netBenefit <= 500 && netBenefit > 100) {
    return 'ETB 100Mn-ETB 500Mn';
  } else if (netBenefit <= 1000 && netBenefit > 500) {
    return 'ETB 500Mn-ETB 1Bn';
  } else {
    return '>ETB 1Bn';
  }
};

export default getNetRecurringBenefitCategory;